export default __webpack_public_path__ + "static/media/flair.2b8a1d36.png";